export const structureTableHeaders = (context) => {
    const {entidadeItem, entidadeNivel, entidadeCategoria, entidadeLocal, entidadeProcesso, entidadeSubItem} = context
      return [
        {
          title: 'Código',
          align: 'center',
          key: 'codigo',
          sortable: true,
        },
        {
          title: entidadeSubItem?.nome,
          align: 'center',
          key: 'oferta_curso',
          sortable: true
        },
        {
          title: entidadeItem?.nome,
          align: 'center',
          key: 'curso',
          sortable: true,
        },
        {
          title: entidadeNivel?.nome,
          align: 'center',
          key: 'nivel_ensino',
          sortable: true,
        },
        {
          title: entidadeCategoria?.nome,
          align: 'center',
          key: 'modalidade',
          sortable: true
        },
        {
          title: entidadeLocal?.nome,
          align: 'center',
          key: 'local_oferta',
          sortable: true
        },
        {
          title: entidadeProcesso?.nome,
          align: 'center',
          key: 'processo_seletivo',
          sortable: true
        }
      ]
    }